import React from 'react';
import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export var Bundles = createSvgIcon(/*#__PURE__*/_jsx("svg", {
  fill: "none",
  height: "20",
  viewBox: "0 0 20 20",
  width: "20",
  xmlns: "http://www.w3.org/2000/svg",
  children: /*#__PURE__*/_jsx("path", {
    d: "M14 3.17521L16.83 6.00521L14 8.83521L11.17 6.00521L14 3.17521ZM6.34003 3.65521V7.65521H2.34003V3.65521H6.34003ZM16.34 13.6552V17.6552H12.34V13.6552H16.34ZM6.34003 13.6552V17.6552H2.34003V13.6552H6.34003ZM14 0.345215L8.34003 5.99521L14 11.6552L19.66 5.99521L14 0.345215ZM8.34003 1.65521H0.340027V9.65521H8.34003V1.65521ZM18.34 11.6552H10.34V19.6552H18.34V11.6552ZM8.34003 11.6552H0.340027V19.6552H8.34003V11.6552Z",
    fill: "#999999"
  })
}), 'Bundles');
export var BundlesHover = createSvgIcon(/*#__PURE__*/_jsx("svg", {
  fill: "none",
  height: "20",
  viewBox: "0 0 20 20",
  width: "20",
  xmlns: "http://www.w3.org/2000/svg",
  children: /*#__PURE__*/_jsx("path", {
    d: "M14 3.17521L16.83 6.00521L14 8.83521L11.17 6.00521L14 3.17521ZM6.34003 3.65521V7.65521H2.34003V3.65521H6.34003ZM16.34 13.6552V17.6552H12.34V13.6552H16.34ZM6.34003 13.6552V17.6552H2.34003V13.6552H6.34003ZM14 0.345215L8.34003 5.99521L14 11.6552L19.66 5.99521L14 0.345215ZM8.34003 1.65521H0.340027V9.65521H8.34003V1.65521ZM18.34 11.6552H10.34V19.6552H18.34V11.6552ZM8.34003 11.6552H0.340027V19.6552H8.34003V11.6552Z",
    fill: "#0077D4"
  })
}), 'BundlesHover');
export var BundlesFilled = createSvgIcon(/*#__PURE__*/_jsx("svg", {
  fill: "none",
  height: "20",
  viewBox: "0 0 20 20",
  width: "20",
  xmlns: "http://www.w3.org/2000/svg",
  children: /*#__PURE__*/_jsx("path", {
    d: "M14 3.17521L16.83 6.00521L14 8.83521L11.17 6.00521L14 3.17521ZM6.34003 3.65521V7.65521H2.34003V3.65521H6.34003ZM16.34 13.6552V17.6552H12.34V13.6552H16.34ZM6.34003 13.6552V17.6552H2.34003V13.6552H6.34003ZM14 0.345215L8.34003 5.99521L14 11.6552L19.66 5.99521L14 0.345215ZM8.34003 1.65521H0.340027V9.65521H8.34003V1.65521ZM18.34 11.6552H10.34V19.6552H18.34V11.6552ZM8.34003 11.6552H0.340027V19.6552H8.34003V11.6552Z",
    fill: "#0077D4"
  })
}), 'BundlesFilled');